import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import errorsMixin from './errors-mixin';

export default {
  mixins: [errorsMixin],
  methods: {
    async getExpenses() {
      axios.get(this.userRoute + '/expenses?year=' + this.year)
      .then(response => {
        this.expenses = response.data;
        this.isBusy = false;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getMreaSelect() {
      axios.get(this.userRoute + '/expenses/categories')
      .then(response => {
        this.categories = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getExpenseTypes() {
      axios.get(this.userRoute + '/expenses/types/expenses')
      .then(response => {
        this.expenseTypes = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getIncomeTypes() {
      axios.get(this.userRoute + '/expenses/types/income')
      .then(response => {
        this.incomeTypes = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async delete(row) {
      axios.patch(this.userRoute + "/expenses/" + row.item.id, {
        date: row.item.date,
        description: row.item.description,
        amount: row.item.amount,
        account_used: row.item.account_used,
        category: row.item.category,
        primary_source: row.item.primary_source
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.editable = null;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async exportFinancials() {
      axios.get(this.userRoute + "/export-financials?year=" + this.year)
      .then(response => {
        swal.fire({
          title: 'Export Complete',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Financials',
        }).then(result => {
          if (result.value) {
            window.open(response.data.link, "_blank");
          }
        });
      })
      .catch(error => {
        // 
      });
    },
    resetForm() {
      this.id = null;
      this.form.date = "";
      this.form.type = "";
      this.form.description = "";
      this.form.amount = "";
      this.form.account_used = "";
      this.form.category = "";
      this.form.primary_source = "";
      this.form.recurring = false;
      this.form.confirmed = true;
    }
  }
};